import { DateTime } from "luxon";
import React, { useMemo } from "react";

interface VideoPlayerRulerProps {
  containerWidth: number;
  timeline: [number, number];
  timezone: string;
}

const VideoPlayerRuler: React.FC<VideoPlayerRulerProps> = ({
  containerWidth,
  timeline,
  timezone,
}) => {
  const [start, end] = timeline;
  const totalMs = end - start;

  const ticks = useMemo(() => {
    const tickList: { left: number; isMajor: boolean }[] = [];

    const startTime = DateTime.fromMillis(start).setZone(timezone);
    const alignedStart = startTime
      .startOf("hour")
      .plus({ hours: (6 - (startTime.hour % 6)) % 6 }); // Align to next 6h block

    let cursor = alignedStart;
    while (cursor.toMillis() <= end) {
      const ts = cursor.toMillis();
      const left = Math.floor(((ts - start) / totalMs) * containerWidth);
      const isMajor = cursor.hour === 0;
      tickList.push({ left, isMajor });

      cursor = cursor.plus({ hours: 6 });
    }

    return tickList;
  }, [start, end, containerWidth, timezone, totalMs]);

  return (
    <div className='relative w-full h-4 border-b border-slate-300'>
      {ticks.map((tick, i) => (
        <div
          key={i}
          className='absolute bg-slate-300 w-[1px] bottom-[0]'
          style={{
            left: tick.left,
            height: tick.isMajor ? 14 : 8,
          }}
        />
      ))}
    </div>
  );
};

export default VideoPlayerRuler;
